export default __webpack_public_path__ + "static/media/landing-bg.f20b30a6.webp";